(function(){
  var selector='[data-klx-gst-details]';
  var saveTimer=null;
  var gstPattern=/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

  function values(root){
    var attrs={company_name:'',gstin_number:''};
    if(!root)return attrs;
    root.querySelectorAll('[data-klx-gst-field]').forEach(function(field){
      var key=field.getAttribute('data-klx-gst-field');
      var value=(field.value||'').trim();
      if(key==='gstin_number'){
        value=value.toUpperCase();
        if(field.value!==value) field.value=value;
      }
      attrs[key]=value;
    });
    return attrs;
  }

  function stripGstBlock(note){
    return (note||'')
      .replace(/\n*GST Invoice Details\nBusiness Name:[^\n]*\nGSTIN:[^\n]*\s*$/i,'')
      .trim();
  }

  function noteField(){
    var main=document.querySelector('#main-cart-items textarea[name="note"]');
    if(main)return main;
    return document.querySelector('#header-cart textarea[name="note"], textarea[name="note"]');
  }

  function customerNote(){
    var field=noteField();
    return field?stripGstBlock(field.value||''):'';
  }

  function buildOrderNote(attrs){
    var note=customerNote();
    if(!(attrs.company_name||attrs.gstin_number))return note;
    var gst='GST Invoice Details\nBusiness Name: '+(attrs.company_name||'')+'\nGSTIN: '+(attrs.gstin_number||'');
    return note?note+'\n\n'+gst:gst;
  }

  function sanitizeVisibleNote(){
    document.querySelectorAll('textarea[name="note"]').forEach(function(field){
      var cleaned=stripGstBlock(field.value||'');
      if(field.value!==cleaned)field.value=cleaned;
    });
  }

  function syncHidden(attrs){
    document.querySelectorAll('[data-klx-gst-hidden]').forEach(function(field){
      var key=field.getAttribute('data-klx-gst-hidden');
      field.value=attrs[key]||'';
    });
  }

  function syncVisible(attrs,source){
    document.querySelectorAll(selector).forEach(function(root){
      if(root===source)return;
      root.querySelectorAll('[data-klx-gst-field]').forEach(function(field){
        var key=field.getAttribute('data-klx-gst-field');
        if(document.activeElement!==field && Object.prototype.hasOwnProperty.call(attrs,key)){
          field.value=attrs[key]||'';
        }
      });
      if(attrs.company_name||attrs.gstin_number)root.open=true;
    });
  }

  function syncAcceleratedCheckout(attrs){
    var hasGst=!!(attrs.company_name||attrs.gstin_number);
    document.querySelectorAll('.additional-checkout-buttons,.cart__dynamic-checkout-buttons').forEach(function(el){
      el.style.display=hasGst?'none':'';
    });
  }

  function setStatus(root,state,message){
    if(!root)return;
    root.setAttribute('data-state',state||'');
    var status=root.querySelector('[data-klx-gst-status]');
    if(status)status.textContent=message||'';
  }

  function validate(root,focusInvalid){
    if(!root)return true;
    var attrs=values(root);
    var gstField=root.querySelector('[data-klx-gst-field="gstin_number"]');

    if(!attrs.company_name && !attrs.gstin_number){
      if(gstField)gstField.setCustomValidity('');
      setStatus(root,'','');
      return true;
    }

    if(!attrs.company_name){
      setStatus(root,'error','Enter the legal business / company name for the GST invoice.');
      var companyField=root.querySelector('[data-klx-gst-field="company_name"]');
      if(companyField&&focusInvalid)companyField.focus();
      return false;
    }

    if(!attrs.gstin_number){
      if(gstField){
        gstField.setCustomValidity('Enter your GSTIN to request a GST invoice.');
        if(focusInvalid){gstField.reportValidity();gstField.focus();}
      }
      setStatus(root,'error','Enter GSTIN to request a GST invoice.');
      return false;
    }

    if(!gstPattern.test(attrs.gstin_number)){
      if(gstField){
        gstField.setCustomValidity('Enter a valid Indian GSTIN, for example 24ABCDE1234F1Z5.');
        if(focusInvalid){gstField.reportValidity();gstField.focus();}
      }
      setStatus(root,'error','Please enter a valid Indian GSTIN.');
      return false;
    }

    if(gstField)gstField.setCustomValidity('');
    return true;
  }

  function save(root){
    if(!root)return Promise.resolve(true);
    var attrs=values(root);
    syncHidden(attrs);
    syncVisible(attrs,root);
    syncAcceleratedCheckout(attrs);

    if((attrs.company_name||attrs.gstin_number)&&!validate(root,false))return Promise.resolve(false);

    var payload={
      attributes:attrs,
      note:buildOrderNote(attrs)
    };

    setStatus(root,'saving','Saving GST details…');
    var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';

    return fetch(base+'cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(payload),
      credentials:'same-origin',
      keepalive:true
    }).then(function(response){
      if(!response.ok)throw new Error('Unable to save');
      return response.json();
    }).then(function(){
      setStatus(root,'saved',attrs.company_name||attrs.gstin_number?'GST details saved. They will be printed on the invoice.':'');
      return true;
    }).catch(function(){
      setStatus(root,'error','Could not save GST details. Please try again before checkout.');
      return false;
    });
  }

  function currentRoot(preferCompact){
    var roots=[].slice.call(document.querySelectorAll(selector));
    if(preferCompact){
      var compact=roots.find(function(r){return r.classList.contains('klx-gst-details--compact');});
      if(compact)return compact;
    }
    return roots.find(function(r){return !r.classList.contains('klx-gst-details--compact');})||roots[0]||null;
  }

  function init(){
    sanitizeVisibleNote();
    var root=currentRoot(false)||currentRoot(true);
    if(!root)return;
    var attrs=values(root);
    syncHidden(attrs);
    syncAcceleratedCheckout(attrs);
    if(!(attrs.company_name||attrs.gstin_number))root.open=false;
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();

  document.addEventListener('input',function(event){
    var field=event.target.closest&&event.target.closest('[data-klx-gst-field]');
    if(!field)return;
    var root=field.closest(selector);
    var attrs=values(root);
    syncHidden(attrs);
    syncVisible(attrs,root);
    syncAcceleratedCheckout(attrs);
    validate(root,false);
    clearTimeout(saveTimer);
    saveTimer=setTimeout(function(){save(root);},250);
  });

  document.addEventListener('change',function(event){
    var field=event.target.closest&&event.target.closest('[data-klx-gst-field]');
    if(!field)return;
    clearTimeout(saveTimer);
    save(field.closest(selector));
  });

  document.addEventListener('submit',function(event){
    var form=event.target;
    if(!form)return;

    var root=null;
    if(form.id==='cart')root=currentRoot(false);
    else if(form.closest&&form.closest('#header-cart'))root=currentRoot(true);

    if(!root)return;

    var attrs=values(root);
    syncHidden(attrs);

    if(!(attrs.company_name||attrs.gstin_number))return;

    event.preventDefault();
    if(!validate(root,true))return;

    clearTimeout(saveTimer);
    save(root).then(function(ok){
      if(ok)window.location.href='/checkout';
    });
  },true);

  document.addEventListener('click',function(event){
    var el=event.target.closest&&event.target.closest('a[href*="/checkout"],button[name="checkout"]');
    if(!el)return;

    var root=(el.closest&&el.closest('#header-cart'))?currentRoot(true):currentRoot(false);
    if(!root)return;

    var attrs=values(root);
    if(!(attrs.company_name||attrs.gstin_number))return;

    event.preventDefault();
    if(!validate(root,true))return;

    clearTimeout(saveTimer);
    save(root).then(function(ok){
      if(!ok)return;
      var href=el.getAttribute('href');
      window.location.href=href||'/checkout';
    });
  },true);
})();